// extracted by mini-css-extract-plugin
export default {"notifyFilterScreen":"NotificationFilter_notifyFilterScreen__12zeG","mb24":"NotificationFilter_mb24__O-6Ut","selectalldiv":"NotificationFilter_selectalldiv__QuM-O"};